module.exports = __webpack_public_path__ + "img/plus-circle.cf210f9f.svg";